export const locale = {
 lang: 'fr',
 data: {
     INFORMATIONS:'Informations',
     CONFIRMATION_MESSAGE_PUBLIC_TO_PRIVATE: 'Votre atelier est désormais privé. Vous pouvez ajouter les emails de vos participants pour les inviter.',
     CONFIRMATION_MESSAGE_PRIVATE_TO_PUBLIC: 'Votre atelier est désormais publique. Vous pouvez partager le lien avec vos participants. ',
     BUTTON_MESSAGE: 'Confirmer'
     }
};
